import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

/** Ported from gpp-website blocking popup logo for matching dimensions. */
export const BresBetCompliancePopupLogo = ({ className }: PropsType): React.ReactElement => (
    <SvgElement
        className={className}
        xmlns='http://www.w3.org/2000/svg'
        width='123'
        height='20'
        viewBox='0 0 123 20'
        fill='none'
    >
        <path
            d='M.64.75h8.54c5.124 0 7.329 1.485 7.329 4.733 0 2.474-1.428 3.804-4.069 4.393v.278c3.572.31 4.72 1.392 4.72 4.053 0 3.093-1.987 5.104-7.11 5.104H.64V.75Zm5.59 4.145V8.36h2.857c1.521 0 2.111-.464 2.111-1.763 0-1.206-.528-1.701-2.018-1.701H6.229Zm0 7.146v3.248h3.633c1.211 0 1.77-.619 1.77-1.609 0-1.113-.373-1.64-1.864-1.64H6.23ZM26.539 13.587h-2.05v5.723H18.9V.75h8.572c4.906 0 7.64 2.073 7.64 6.527 0 2.722-1.18 4.485-3.168 5.444l4.254 6.248v.34h-6.49l-3.167-5.723-.001.001Zm-2.05-8.197v4.145h2.671c1.832 0 2.423-.65 2.423-2.073 0-1.516-.776-2.073-2.515-2.073H24.49v.001ZM37.408.75h14.844v4.795h-9.255V8.02h8.633v3.928h-8.633v2.568h9.255v4.794H37.408V.75ZM53.93 14.05l5.31-1.144c.403 1.824 1.863 2.474 3.54 2.474 1.491 0 2.33-.34 2.33-1.175 0-.928-.653-1.484-4.007-2.01-5.186-.774-6.77-2.847-6.77-6.095 0-3.742 2.609-5.815 8.043-5.815 5.435 0 7.516 2.289 7.95 5.382l-5.558 1.052c-.31-1.454-.9-2.197-2.702-2.197-1.491 0-2.205.433-2.205 1.3 0 .742.28 1.33 3.665 1.887 6.055 1.02 7.204 3.371 7.204 6.155 0 3.743-2.453 5.909-8.199 5.909-6.428 0-8.26-2.785-8.602-5.723ZM72.748.75h8.54c5.124 0 7.33 1.485 7.33 4.733 0 2.474-1.43 3.804-4.07 4.393v.278c3.572.31 4.721 1.392 4.721 4.053 0 3.093-1.987 5.104-7.112 5.104h-9.409V.75Zm5.59 4.145v3.464h2.857c1.522 0 2.112-.464 2.112-1.762 0-1.207-.528-1.702-2.02-1.702h-2.95.001Zm0 7.145v3.248h3.633c1.212 0 1.77-.619 1.77-1.608 0-1.114-.372-1.64-1.863-1.64h-3.54ZM91.007.75h14.844v4.795h-9.254V8.02h8.633v3.928h-8.633v2.568h9.254v4.794H91.007V.75ZM106.814.75h15.403v5.104h-4.906V19.31h-5.59V5.854h-4.907V.75Z'
            fill='#ED3FAA'
        />
    </SvgElement>
);
